// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2DXrp","errors":"Errors_errors__3NbiA"};